import React from 'react'
import { FormattedMessage } from 'react-intl'
import { LimitStatusWrapper, LabelProgress, Label, TextColumns } from './s'
import { Signature } from 'components/feather'
import { Plain } from 'components/button'
import { ParagraphSmall } from 'components/typography/paragraph'
import ProgressIndicator from 'components/progress-indicator'
import { size } from 'utilities/object'

const LimitStatus = ({ quota, viewDetails }) => {
    if(!size(quota)) {
        return null
    }

    const { percentRemaining } = enrichQuota(quota)
    if(percentRemaining >= 20) {
        return null
    }

    return (
        <LimitStatusWrapper>
            <LimitStatusLabelProgress
                quota={quota}
                viewDetails={viewDetails} />
        </LimitStatusWrapper>
    )
}

export const LimitStatusLabelProgress = ({ quota, viewDetails }) => {
    if(!size(quota)) {
        return null
    }

    const {
        used,
        limit,
        percentRemaining
    } = enrichQuota(quota)

    return (
        <LabelProgress>
            <TextColumns className="compact">
                <Label>
                    <Signature size={16} />
                    <ParagraphSmall className="compact">
                        <FormattedMessage
                            id="document_signing_quota_count_of_total_remaining"
                            defaultMessage="{count, plural, =0 {{count} of {total} documents left} =1 {{count} of {total} document left} other {{count} of {total} documents left}}"
                            values={{
                                count: limit - used,
                                total: limit
                            }} />
                    </ParagraphSmall>
                </Label>
                {!!viewDetails && (
                    <Plain
                        className="constructive small"
                        onClick={viewDetails}>
                        <FormattedMessage
                            id="action_view_details"
                            defaultMessage="View details" />
                    </Plain>
                )}
            </TextColumns>
            <ProgressIndicator values={[percentRemaining]} />
        </LabelProgress>
    )
}

export const enrichQuota = quota => {
    if(!quota || !size(quota)) {
        return quota
    }

    const {
        value: used,
        limit
    } = quota

    return {
        used,
        limit,
        percentRemaining: ((limit - used) / limit) * 100
    }
}

export default LimitStatus
